import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
    DaButton,
    ModalProvider,
    ModalControl,
    TrashIcon,
    LeafIcon,
} from '@paygreen/paygreen-ui';
import { DeleteButton, ModalControlClose } from '../../../components/';
import { IsMobile } from '../../../utils/tools';
import { actionProductModes } from '../../../utils/constants';
import GroupedProductsModal from './GroupedProductsModal';

const GroupedActionsButtons = ({
    t,
    selectedRows,
    dataMatching,
    handleRefreshData,
}) => {
    const [editProductMode, setEditProductMode] = useState();

    const actionIconProps = {
        iconSize: 'md',
        colorPallet: 'status',
        hasBackground: true,
        hasHover: true,
        isActive: true,
    };

    const switchToDeleteMode = () => {
        setEditProductMode(actionProductModes.delete);
    };

    const switchToMatchMode = () => {
        setEditProductMode(actionProductModes.match);
    };

    return (
        <>
            <ModalProvider>
                <ModalControl>
                    <ModalControlClose action={switchToMatchMode}>
                        {IsMobile() ? (
                            <LeafIcon
                                htmlTag="button"
                                title={t('matching.grouped.matchButton')}
                                colorStatus="success"
                                {...actionIconProps}
                            />
                        ) : (
                            <button type="reset">
                                <DaButton
                                    buttonSize="md"
                                    buttonStyle="fill"
                                    colorPallet="status"
                                    colorStatus="success"
                                    icon={<LeafIcon />}
                                >
                                    {t('matching.grouped.matchButton')}
                                </DaButton>
                            </button>
                        )}
                    </ModalControlClose>

                    <ModalControlClose action={switchToDeleteMode}>
                        {IsMobile() ? (
                            <TrashIcon
                                htmlTag="button"
                                title={t('matching.grouped.deleteButton')}
                                colorStatus="danger"
                                {...actionIconProps}
                            />
                        ) : (
                            <DeleteButton
                                buttonSize="md"
                                buttonStyle="fill"
                                icon="TrashIcon"
                            >
                                {t('matching.grouped.deleteButton')}
                            </DeleteButton>
                        )}
                    </ModalControlClose>
                </ModalControl>

                <ModalControl>
                    <GroupedProductsModal
                        selectedRows={selectedRows}
                        productsData={dataMatching}
                        mode={editProductMode}
                        handleRefreshData={handleRefreshData}
                    />
                </ModalControl>
            </ModalProvider>
        </>
    );
};

GroupedActionsButtons.propTypes = {
    selectedRows: PropTypes.array,
    dataMatching: PropTypes.array,
    handleRefreshData: PropTypes.func,
};

export default withTranslation('common')(GroupedActionsButtons);
